import * as Sentry from '@sentry/react';
import * as React from 'react';

import { ActionableContainerSkeleton, Button } from '@gitbook/spine-react';

import { IntegrationConfigureOrgFlow, IntegrationStepWrapper } from '../../../../Components';
import { useSetAnalyticsScreen } from '../../../../navigation';
import { IntegrationsEmptyState } from '../../components';
import type { IntegrationInstallationFlowProps } from '../types';
import { isConfigurationStatusKnowable } from '../utils';

type OrgConfigurationStepProps = IntegrationInstallationFlowProps & {
    onNext: () => void;
};

/**
 * Step to configure the integration for a content context.
 */
export function OrgConfigurationStep(props: OrgConfigurationStepProps) {
    const { integration, installation, organizationId, onNext } = props;

    const isConfigStateKnowable = isConfigurationStatusKnowable(integration);

    useSetAnalyticsScreen({
        screen: 'integration_installation',
        step: 'configure_content_installation',
        integration: integration.name,
        organization: organizationId,
        withAccountInstallation: !!installation,
        withContentInstallation: false,
    });

    return (
        <div className="h-full overflow-y-auto">
            <IntegrationStepWrapper
                title={`Configure ${integration.title}`}
                status={installation.status}
            >
                <Sentry.ErrorBoundary fallback={<IntegrationsEmptyState kind="no-installation" />}>
                    <React.Suspense fallback={<ActionableContainerSkeleton />}>
                        <IntegrationConfigureOrgFlow
                            integration={integration}
                            installation={installation}
                            onComplete={onNext}
                        />
                        {isConfigStateKnowable ? (
                            <Button
                                label="Done"
                                kind="primary"
                                onPress={onNext}
                                className="mt-auto self-end"
                            />
                        ) : null}
                    </React.Suspense>
                </Sentry.ErrorBoundary>
            </IntegrationStepWrapper>
        </div>
    );
}
